import type { CSSProperties } from 'react'
import { cn } from '../../lib/utils'

/**
 * A one-color SVG from public/ (the Bridge Figma exports), drawn in the
 * current text color through a CSS mask. The exports hard-code their stroke
 * (#1A1A1A, black), which vanishes in dark mode; as a mask only their shape
 * counts, so the icon follows the theme like text does. Set the color with a
 * text-* class.
 */
export default function SvgIcon({ src, width, height, className }: {
  src: string
  width: number
  height: number
  className?: string
}) {
  const mask = `url("${src}") center / contain no-repeat`
  const style: CSSProperties = { width, height, mask, WebkitMask: mask }
  return <span aria-hidden className={cn('inline-block shrink-0 bg-current', className)} style={style} />
}
